import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import strings from '../locales/';
import TitleMain from '../common/titleMain';
import BehaviorIndicatorsBlock from '../common/behavior/behaviorIndicatorsBlock';
import CircularIndicator from '../common/indicators/circularIndicator';
import SimpleIndicator from '../common/indicators/simpleIndicator';
import Label from '../common/label';

const ModalHeader = Modal.Header;
const ModalTitle = Modal.Title;
const ModalBody = Modal.Body;

const TravelDetailModal = props => (
  <Modal
    onHide={props.onHide}
    show={props.show}
    bsSize="lg"
    className={'system-modal travel-detail-modal'}
  >
    <div className={'modalContent'}>
      <ModalHeader closeButton>
        <ModalTitle id="contained-modal-title-lg">
          {props.language.driver_behavior.title.travelDetail}
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className="modal-body-inner">
          <TitleMain title={props.language.driver_behavior.title.travelMainIndicators} />
          {props.data && (
            <section className="content-inner">
              <section className="driver-behavior-grade-wrapper">
                <CircularIndicator
                  size={130}
                  max={100}
                  value={props.data.behaviorGrade}
                  fill={false}
                  valueFormat={{ type: 'NUMBER', format: '.0f' }}
                  graphColorRange={props.graphColorRange}
                />
                <Label label={props.language.driver_behavior.labels.behaviorGrade} />
                <section className="travel-idicators">
                  <SimpleIndicator
                    value={props.data.travelKms}
                    valueFormat={{ type: 'NUMBER', format: '.0f', sufix: ' Km' }}
                  />
                  <SimpleIndicator
                    value={props.data.travelTimeLength}
                    valueFormat={{ type: 'NUMBER', format: 'hh:mm' }}
                  />
                </section>
              </section>
              <BehaviorIndicatorsBlock
                extraId={'modal'}
                data={{
                  behaviorGrade: props.data.behaviorGrade,
                  indicators: props.data.indicators
                }}
                config={props.config}
                graphColorRange={props.graphColorRange}
              />
            </section>
          )}
        </div>
      </ModalBody>
    </div>
  </Modal>
);

export default TravelDetailModal;



// WEBPACK FOOTER //
// ./source/client/components/driver_behavior/travelDetailModal.jsx